"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreDataTable = exports.CoreDataTableV2 = void 0;
var IctCoreJsApp_1 = require("./../Core/IctCoreJsApp");
require("./JQueryExtensions");
require("datatables.net");
require("datatables.net");
require("datatables.net-bs4");
require("datatables.net-buttons");
require("datatables.net-buttons-bs4");
require("datatables.net-buttons/js/buttons.colVis.js");
require("datatables.net-buttons/js/buttons.html5.js");
require("datatables.net-colreorder");
require("datatables.net-colreorder-bs4");
require("datatables.net-select");
require("datatables.net-select-bs4");
var CoreDataTableV2 = (function () {
    function CoreDataTableV2(element, options) {
        var _a;
        this.allRows = [];
        this._keyListInitializedWithAllSelected = false;
        this.element = element;
        this.options = options;
        this._keyListInitialized = false;
        this._datatableKeyList = [];
        var initialIds = (_a = $(this.element).data('initial-selected-ids')) === null || _a === void 0 ? void 0 : _a.toString();
        this._datatableSelectedList = [];
        if (initialIds) {
            if (initialIds == '-1') {
                this._keyListInitializedWithAllSelected = true;
            }
            else if (initialIds.length > 0) {
                this._datatableSelectedList = initialIds.split(',');
            }
        }
        this._tableKeyProperty = '';
        this._isSearching = false;
        this._searchString = '';
        this._searchItemsKeyCache = new Map();
    }
    CoreDataTableV2.prototype.getSelectStatus = function () {
        return {
            selectAll: this._datatableKeyList.length == this._datatableSelectedList.length,
            selectedIds: this._datatableSelectedList,
        };
    };
    CoreDataTableV2.prototype.reindexKeyData = function () {
        var _this_1 = this;
        this.getKeyDataFromServer(null).then(function (callbackResult) {
            _this_1._datatableKeyList = callbackResult.data.map(function (d) { return d[_this_1._tableKeyProperty].toString(); });
            _this_1.changeSelectedFooterCount();
        }).catch(function (error) {
            console.error("An error occured while getting the id list for datatable: ".concat(error));
        });
    };
    CoreDataTableV2.prototype.Create = function () {
        var _this_1 = this;
        var _this = this;
        var tableId = _this.options.connxtTableid;
        var $table = $('table[data-connxt-tableid="' + tableId + '"]');
        this.options.dom = '<"connxt-dt-top"<"dt-top-search"f><"pull-right table-buttons"B>><"connxt-dt-table table-responsive"rt><"connxt-dt-bottom"lip>';
        this.options.pagingType = 'full';
        this._tableKeyProperty = $table.data('key-property');
        if (_this.options.buttons == null) {
            _this.options.buttons = new Array();
            var exportButton = {};
            exportButton.text = '<i class="fal fa-download"></i>';
            exportButton.className = 'btn-sm px-3';
            exportButton.action = function (e, dt, node, config) {
                var currentColumnOrder = _this.datatable.colReorder.order();
                var visibleColumns = [];
                var allColumns = dt.settings().init().columns;
                if (allColumns != null) {
                    for (var j = 0; j < currentColumnOrder.length; j++) {
                        if (dt.column(allColumns[currentColumnOrder[j]].name + ':name').visible()) {
                            visibleColumns.push(allColumns[currentColumnOrder[j]].name);
                        }
                    }
                }
                var search = $table.closest('.dataTables_wrapper').find('input[type=search]').val();
                $.ajax({
                    type: 'GET',
                    data: {},
                    url: '/Common/Table/ConfigureExport?sourceId=' + tableId + '&columns=' + visibleColumns.join(',') + '&filter=' + search,
                    success: function (response) {
                        var _a, _b, _c, _d, _e, _f;
                        if ($('#exportmodal').length)
                            $('#exportmodal').remove();
                        $("body").append(response);
                        var exportLimit = (_a = window['Common_ExportRowLimit']) !== null && _a !== void 0 ? _a : 5000;
                        if (_this_1.datatable != null && _this_1.datatable.page.info().recordsTotal > exportLimit) {
                            $("#configureexport p.note.note-warning").show();
                        }
                        var exportForm = $('#exportform');
                        var params;
                        var parameterNumber = 0;
                        if (!(_this.options.ajaxCustomData && {}.toString.call(_this_1.options.ajaxCustomData) === '[object Function]')) {
                            params = [].filter.call(_this.element[0].attributes, function (at) { return /^data-parameter-/.test(at.name); });
                            $(".export-parameter").remove();
                            params.forEach(function (value) {
                                var paramName = value.name.replace('data-parameter-', '');
                                $('#exportform').append('<input class="export-parameter" type="hidden" name="Parameters[' + parameterNumber + '].Key" value="' + paramName + '" />');
                                $('#exportform').append('<input class="export-parameter" type="hidden" name="Parameters[' + parameterNumber + '].Value" value="' + value.value + '" />');
                                parameterNumber++;
                            });
                        }
                        else {
                            ((_b = _this.datatable) === null || _b === void 0 ? void 0 : _b.ajax.params()).parameters.forEach(function (value) {
                                var _a;
                                $('#exportform').append('<input class="export-parameter" type="hidden" name="Parameters[' + parameterNumber + '].Key" value="' + value.Name + '" />');
                                $('#exportform').append('<input class="export-parameter" type="hidden" name="Parameters[' + parameterNumber + '].Value" value="' + ((_a = value.Value) !== null && _a !== void 0 ? _a : '') + '" />');
                                parameterNumber++;
                            });
                        }
                        $(".export-order").remove();
                        var orderNumber = 0;
                        (_c = _this.datatable) === null || _c === void 0 ? void 0 : _c.order().forEach(function (value) {
                            $('#exportform').append('<input class="export-order" type="hidden" name="Order[' + orderNumber + '].Key" value="' + value[0] + '" />');
                            $('#exportform').append('<input class="export-order" type="hidden" name="Order[' + orderNumber + '].Value" value="' + value[1] + '" />');
                            orderNumber++;
                        });
                        $(".export-column").remove();
                        var columnNumber = 0;
                        ((_d = _this.datatable) === null || _d === void 0 ? void 0 : _d.settings().init().columns).forEach(function (column) {
                            $('#exportform').append('<input class="export-column" type="hidden" name="DatasourceColumns[' + columnNumber + '].Name" value="' + column.name + '" />');
                            $('#exportform').append('<input class="export-column" type="hidden" name="DatasourceColumns[' + columnNumber + '].data" value="' + column.data + '" />');
                            columnNumber++;
                        });
                        exportForm.find('select').materialSelect();
                        if (!((_e = _this.datatable) === null || _e === void 0 ? void 0 : _e.page.info().serverSide)) {
                            $('#exportform').append('<input class="export-column" type="hidden" name="TableKeyProperty" value="' + _this_1._tableKeyProperty + '" />');
                            var columnNumber_1 = 0;
                            ((_f = _this.datatable) === null || _f === void 0 ? void 0 : _f.rows({ "search": "applied" }).data().pluck(_this._tableKeyProperty).toArray().slice(0, exportLimit)).forEach(function (row) {
                                $('#exportform').append('<input class="export-column" type="hidden" name="KeysToExport[' + columnNumber_1 + ']" value="' + row + '" />');
                                columnNumber_1++;
                            });
                        }
                        $('.preload-select-spinner-wrapper').hide();
                        exportForm.find('#exportcancel').on("click", function (e) {
                            e.preventDefault();
                            $('#exportmodal').modal('hide');
                            return false;
                        });
                        exportForm.find('#exportdata').on('click', function () {
                            $('#exportdata').html('<i class="fa-solid fa-sync fa-spin" />');
                            $("#exportdata").attr('disabled', 'disabled');
                            $.ajax({
                                url: '/Common/Table/PrepareExport',
                                type: 'post',
                                data: exportForm.serialize(),
                                success: function (data) {
                                    window.open('/Common/Table/GetExport/' + data);
                                },
                                error: function (jqXHR, textStatus, errorThrown) {
                                    if (errorThrown != "abort") {
                                        var message = '';
                                        if (jqXHR.responseJSON != null && jqXHR.responseJSON.message != null) {
                                            message = jqXHR.responseJSON.message;
                                        }
                                        if (message !== undefined && message != '') {
                                            IctCoreJsApp_1.$app.snackbar.show({
                                                message: message
                                            });
                                        }
                                        console.error("Failed to export data: ".concat(message));
                                    }
                                },
                                complete: function () {
                                    $('#exportmodal').modal('hide');
                                }
                            }).catch(function (error) {
                                console.error("Failed to prepare export: ".concat(error));
                            });
                            return false;
                        });
                        $('.select-wrapper li input[type="checkbox"]').addClass("filled-in");
                        $('#exportmodal').modal({
                            keyboard: false
                        });
                    }
                }).catch(function (error) {
                    console.error("Failed to configure export: ".concat(error));
                });
            };
            if (_this.options.parameters && _this.options.parameters.length > 0) {
                var settingsButton = {};
                settingsButton.text = '<i class="fal fa-gear"></i>';
                settingsButton.className = 'btn-sm px-3 dt-parameter-btn';
                settingsButton.action = function (e, dt, node, config) {
                    $.ajax({
                        type: 'GET',
                        data: {},
                        url: '/Common/Table/ConfigureParameters?sourceId=' + tableId,
                        success: function (response) {
                            if ($('#parametersmodal').length)
                                $('#parametersmodal').remove();
                            $("body").append(response);
                            $('#parametersmodal').modal();
                        }
                    }).catch(function (error) {
                        console.error("Failed to configure parameters: ".concat(error));
                    });
                };
                for (var _i = 0, _a = _this.options.parameters; _i < _a.length; _i++) {
                    var parameter = _a[_i];
                    var localStorageValue = window.localStorage.getItem('datatable-' + tableId + '-parameter-' + parameter.Name);
                    if (localStorageValue != null) {
                        $table.data('parameter-' + parameter.Name, localStorageValue);
                        $table.attr('data-' + 'parameter-' + parameter.Name, localStorageValue);
                    }
                }
                _this.options.buttons.push(settingsButton);
            }
            if (_this.options.connxtAllowExport) {
                _this.options.buttons.push(exportButton);
            }
            var toggleColumnVisibilityButton = {};
            toggleColumnVisibilityButton.extend = 'colvis';
            toggleColumnVisibilityButton.className = 'btn-sm';
            toggleColumnVisibilityButton.text = '<i class="fal fa-table-list"></i>';
            toggleColumnVisibilityButton.columns = ':not(.noselect)';
            if (_this.options.connxtAllowToggleColumnVisibility) {
                _this.options.buttons.push(toggleColumnVisibilityButton);
            }
        }
        if (_this.options.stateSaveCallback == null) {
            _this.options.stateSaveCallback = function (settings, data) {
                var hierarchyId = '' + $(settings.nTable).data('connxt-hierarchyid');
                var checksumKey = "_DataTable_Def_Checksum";
                var userId = "" + $(settings.nTable).data('connxt-userid');
                var isStateHierarchySpecific = "" + $(settings.nTable).data('connxt-state-hierarchyspecific');
                var stateKey = 'DataTables_' + settings.sInstance + "_" + userId;
                var checksum = $(settings.nTable).data('datatable-columns-checksum');
                var currentChecksum = localStorage.getItem(_this.options.connxtTableid + checksumKey);
                if (currentChecksum !== checksum) {
                    localStorage.removeItem(stateKey);
                }
                var columnState = JSON.parse(window.localStorage.getItem(stateKey));
                var sessionState = JSON.parse(window.sessionStorage.getItem(stateKey));
                if (columnState == null) {
                    columnState = {};
                }
                columnState.columns = data.columns;
                columnState.ColReorder = data.ColReorder;
                if (sessionState == null) {
                    sessionState = {
                        states: {}
                    };
                }
                delete data.columns;
                delete data.ColReorder;
                if (isStateHierarchySpecific) {
                    for (var state in sessionState.states) {
                        if (sessionState.states[state].hierarchyId !== hierarchyId) {
                            sessionState.states[state].search.search = "";
                            sessionState.states[state].start = 0;
                            sessionState.states[state].length = 10;
                            sessionState.states[state].order = null;
                            sessionState.states[state].time = 0;
                        }
                    }
                    data.hierarchyId = hierarchyId;
                    sessionState.states[hierarchyId] = data;
                }
                else {
                    sessionState.search = data.search;
                    sessionState.start = data.start;
                    sessionState.length = data.length;
                    sessionState.order = data.order;
                }
                sessionState.time = (new Date().getTime() / 1000 | 0) + 3600;
                localStorage.setItem(stateKey, JSON.stringify(columnState));
                localStorage.setItem(_this.options.connxtTableid + checksumKey, checksum);
                sessionStorage.setItem(stateKey, JSON.stringify(sessionState));
            };
        }
        if (_this.options.stateLoadCallback == null) {
            _this.options.stateLoadCallback = function (settings) {
                var hierarchyId = '' + $(settings.nTable).data('connxt-hierarchyid');
                var userId = "" + $(settings.nTable).data('connxt-userid');
                var isStateHierarchySpecific = "" + $(settings.nTable).data('data-connxt-state-hierarchyspecific');
                var stateKey = 'DataTables_' + settings.sInstance + "_" + userId;
                var columnStateJson = window.localStorage.getItem(stateKey);
                var sessionStateJson = window.sessionStorage.getItem(stateKey);
                var state = null;
                if (columnStateJson == null) {
                    return null;
                }
                else {
                    var columnState = JSON.parse(columnStateJson);
                    state = {};
                    state.columns = columnState.columns;
                    state.ColReorder = columnState.ColReorder;
                }
                if (sessionStateJson != null) {
                    var sessionState = JSON.parse(sessionStateJson);
                    if (isStateHierarchySpecific) {
                        if (sessionState.states[hierarchyId] != null) {
                            var tableStateForHierarchyId = sessionState.states[hierarchyId];
                            if (state === null)
                                state = {};
                            if (tableStateForHierarchyId.time > ((new Date().getTime() / 1000 | 0) + 3600)) {
                                state.search = tableStateForHierarchyId.search;
                                state.start = tableStateForHierarchyId.start;
                                state.length = tableStateForHierarchyId.length;
                                state.order = tableStateForHierarchyId.order;
                            }
                            else {
                                state.search = {
                                    search: '',
                                    smart: true,
                                    regex: false,
                                    caseInsensitive: true
                                };
                                state.start = 0;
                                state.length = 10;
                                delete state.order;
                            }
                        }
                    }
                    else {
                        state.search = sessionState.search;
                        state.start = sessionState.start;
                        state.length = sessionState.length;
                        state.order = sessionState.order;
                    }
                }
                state.time = new Date('2100-01-01').getTime() / 1000;
                return state;
            };
        }
        if (_this.options.url != null && _this.options.ajax == null) {
            _this.options.ajax = {
                url: _this.options.url,
                type: 'POST',
                beforeSend: function (request) {
                    request.setRequestHeader('X-CSRF-TOKEN', IctCoreJsApp_1.$app.getAntiForgeryCookie());
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    if (errorThrown != "abort") {
                        var message = '';
                        if (jqXHR.responseJSON != null && jqXHR.responseJSON.message != null) {
                            message = jqXHR.responseJSON.message;
                        }
                        if (message !== undefined && message != '') {
                            IctCoreJsApp_1.$app.snackbar.show({
                                message: message
                            });
                        }
                        console.error("Failed to get data for datatable: ".concat(message));
                        if (_this_1.options.processing == true) {
                            $('#' + _this.element[0].id + '_processing').hide();
                        }
                        _this.hideLoader();
                    }
                }
            };
            var params_1 = [].filter.call(_this.element[0].attributes, function (at) { return /^data-parameter-/.test(at.name); });
            if (!(this.options.ajaxCustomData && {}.toString.call(this.options.ajaxCustomData) === '[object Function]')) {
                this.options.ajaxCustomData = function (data, settings) {
                    var _a, _b;
                    if (settings.ajax.data == null) {
                        settings.ajax.data = {};
                    }
                    data.parameters = [];
                    params_1.forEach(function (value) {
                        var paramName = value.name.replace('data-parameter-', '');
                        if (data.parameters.filter(function (value) { return value.name == paramName; }).length == 0) {
                            data.parameters.push({ Name: paramName, Value: value.value });
                        }
                    });
                    var visibleColumns = [];
                    var allColumns = (_a = _this.datatable) === null || _a === void 0 ? void 0 : _a.settings().init().columns;
                    if (allColumns != null) {
                        for (var j = 0; j < allColumns.length; j++) {
                            if ((_b = _this.datatable) === null || _b === void 0 ? void 0 : _b.column(allColumns[j].name + ':name').visible()) {
                                visibleColumns.push(allColumns[j].name);
                            }
                        }
                    }
                    data.parameters.push({ Name: 'visible-columns', Value: visibleColumns.join(',') });
                };
            }
            else {
                var fnGetCustomData_1 = this.options.ajaxCustomData;
                this.options.ajaxCustomData = function (data, settings) {
                    var _a, _b;
                    fnGetCustomData_1(data, settings);
                    if (data.parameters == null) {
                        data.parameters = [];
                    }
                    params_1.forEach(function (value) {
                        var paramName = value.name.replace('data-parameter-', '');
                        if (data.parameters.filter(function (value) { return value.name == paramName; }).length == 0) {
                            data.parameters.push({ Name: paramName, Value: value.value });
                        }
                    });
                    var visibleColumns = [];
                    var allColumns = (_a = _this.datatable) === null || _a === void 0 ? void 0 : _a.settings().init().columns;
                    if (allColumns != null) {
                        for (var j = 0; j < allColumns.length; j++) {
                            if ((_b = _this.datatable) === null || _b === void 0 ? void 0 : _b.column(allColumns[j].name + ':name').visible()) {
                                visibleColumns.push(allColumns[j].name);
                            }
                        }
                    }
                    data.parameters.push({ Name: 'visible-columns', Value: visibleColumns.join(',') });
                };
            }
            _this.options.ajax.data = this.options.ajaxCustomData;
        }
        ;
        if (_this.options.connxtAllowSelect) {
            _this.options.select =
                {
                    style: 'multi+shift',
                    className: 'row-selected',
                    selector: 'td:first-child',
                    info: false
                };
        }
        _this.showLoader();
        $(this.element).parents('div.dataTables_wrapper').first().hide();
        if (_this.options.initComplete == null) {
            _this.options.initComplete = function (settings) {
                var _a;
                _this.hideLoader();
                if (_this.datatable) {
                    _this.datatable.columns.adjust();
                    _this_1.setSearchDebounce(_this.datatable, 750);
                    if (!_this.options.serverSide) {
                        var allRows_1 = [];
                        _this.datatable.rows(function (rowIdx, data) {
                            allRows_1.push(data);
                        });
                        _this_1.allRows = allRows_1;
                    }
                }
                if (_this.options.renderButtonsHeader) {
                    var buttons_1 = $(".manage-table-buttons");
                    (_a = _this_1.datatable) === null || _a === void 0 ? void 0 : _a.columns(":last").every(function () {
                        buttons_1.appendTo(this.header());
                    });
                }
                if (_this.options.connxtAllowSelect) {
                    var $selectAllCheckbox = ('<div class="md-form pt-0"><div class="form-check pl-0" style="line-height:0;"><input id="selectall" name="selectall" class="filled-in form-check-input" style="line-height:0" type="checkbox" value="" /><label class="pb-0 mb-0" style="margin-top:5px;" for="selectall"></label></div></div>');
                    $(_this_1.element).find('th.select-checkbox').append($selectAllCheckbox);
                    var tableId_1 = $(_this_1.element).attr('id');
                    var selectRowsLabel = $(_this_1.element).data('localized-select-label');
                    var selectCountTag = '<div class="dataTables_selected_count" id="' + tableId_1 + '_select_count"><div class="selected_count_label">0 </div><label>' + selectRowsLabel + '</label></div>';
                    $(selectCountTag).insertAfter($("[id='".concat(tableId_1, "_paginate']")));
                }
            };
        }
        var loaderOverride = _this.getCustomLoader();
        if (loaderOverride) {
            _this.options.language.processing = "<div class=\"dt-processing-overlay\">" + loaderOverride + "</div>";
        }
        this.initDataTable(this.options);
        $(this.element).data('table-initialized', 'true');
    };
    CoreDataTableV2.prototype.updateCheckboxState = function () {
        var _a;
        var _this = this;
        var $selectAllCheckbox = $(this.element).find('input#selectall');
        if ($selectAllCheckbox.length != 1) {
            return;
        }
        if (_this._datatableKeyList.length != 0) {
            if (_this._datatableKeyList.length == _this._datatableSelectedList.length) {
                $selectAllCheckbox.attr('checked', 'checked');
            }
            else {
                $selectAllCheckbox.removeAttr('checked');
            }
        }
        (_a = this.datatable) === null || _a === void 0 ? void 0 : _a.rows(function (idx, data, node) {
            var _a, _b;
            if (_this._datatableSelectedList.includes((_a = data[_this._tableKeyProperty]) === null || _a === void 0 ? void 0 : _a.toString())) {
                (_b = _this.datatable) === null || _b === void 0 ? void 0 : _b.row(idx).select();
            }
        });
        this.changeSelectedFooterCount();
    };
    CoreDataTableV2.prototype.initDataTable = function (dataTableSettings) {
        var _this_1 = this;
        var _this = this;
        var table = $(this.element).DataTable(dataTableSettings);
        this.datatable = table;
        if (dataTableSettings.connxtAllowSelect) {
            this.datatable.on('select', function (e, dt, type, indexes) {
                indexes.forEach(function (index) {
                    table[type](index).nodes().to$().find('input').attr('checked', 'checked');
                    var rowId = table.row(index).data()[_this._tableKeyProperty];
                    if (!_this._datatableSelectedList.includes(rowId.toString())) {
                        _this._datatableSelectedList.push(rowId.toString());
                    }
                });
                var selectAllCheckboxClicked = false;
                if (indexes.length == table.page.len()) {
                    selectAllCheckboxClicked = true;
                    if (!_this._isSearching && indexes.length > 1) {
                        _this._datatableSelectedList = _this.combineListsWithDistinct(_this._datatableSelectedList, _this._datatableKeyList);
                    }
                    else if (_this._isSearching && indexes.length > 1) {
                        if (_this._searchItemsKeyCache.has(_this._searchString)) {
                            var searchResult = _this._searchItemsKeyCache.get(_this._searchString);
                            _this._datatableSelectedList = _this.combineListsWithDistinct(_this._datatableSelectedList, searchResult !== null && searchResult !== void 0 ? searchResult : []);
                        }
                        else {
                            _this.getKeyDataFromServer(_this._searchString).then(function (callbackResult) {
                                var searchResult = callbackResult.data.map(function (d) { return d[_this._tableKeyProperty]; });
                                ;
                                _this._searchItemsKeyCache.set(_this._searchString, searchResult);
                                _this._datatableSelectedList = _this.combineListsWithDistinct(_this._datatableSelectedList, searchResult);
                                _this.changeSelectedFooterCount();
                            }).catch(function (error) {
                                console.error("An error occured while getting the id list for datatable: ".concat(error));
                            });
                        }
                    }
                }
                var $selectAllCheckbox = $(_this.element).find('input#selectall');
                if (_this._datatableKeyList.length == _this._datatableSelectedList.length || selectAllCheckboxClicked) {
                    $selectAllCheckbox.attr('checked', 'checked');
                }
                else {
                    $selectAllCheckbox.removeAttr('checked');
                }
                _this.changeSelectedFooterCount();
            });
            this.datatable.on('deselect', function (e, dt, type, indexes) {
                var _a;
                var $selectAllCheckbox = $(_this.element).find('input#selectall');
                $selectAllCheckbox.removeAttr('checked');
                if (indexes.length == table.page.len()) {
                    if (!_this._isSearching && indexes.length > 1) {
                        _this._datatableSelectedList = [];
                    }
                    else if (_this._isSearching && indexes.length > 1) {
                        if (_this._searchItemsKeyCache.has(_this._searchString)) {
                            var searchResult_1 = (_a = _this._searchItemsKeyCache.get(_this._searchString)) !== null && _a !== void 0 ? _a : [];
                            _this._datatableSelectedList = _this._datatableSelectedList.filter(function (x) { return !searchResult_1.includes(x); });
                        }
                        else {
                            _this.getKeyDataFromServer(_this._searchString).then(function (callbackResult) {
                                var searchResult = callbackResult.data.map(function (d) { return d[_this._tableKeyProperty]; });
                                _this._searchItemsKeyCache.set(_this._searchString, searchResult);
                                _this._datatableSelectedList = _this._datatableSelectedList.filter(function (x) { return !searchResult.includes(x); });
                                _this.changeSelectedFooterCount();
                            }).catch(function (error) {
                                console.error("An error occured while getting the id list for datatable: ".concat(error));
                            });
                        }
                    }
                }
                indexes.forEach(function (index) {
                    table[type](index).nodes().to$().find('input').removeAttr('checked');
                    var rowId = table.row(index).data()[_this._tableKeyProperty];
                    var selectedIdsListIndex = _this._datatableSelectedList.indexOf(rowId.toString());
                    if (selectedIdsListIndex >= 0) {
                        _this._datatableSelectedList.splice(selectedIdsListIndex, 1);
                    }
                });
                _this.changeSelectedFooterCount();
            });
        }
        this.datatable.on('column-reorder', function () {
            setTimeout(function () { return _this_1.callbackFuncion(dataTableSettings); });
        });
        this.datatable.on('draw', function () {
            setTimeout(function () {
                if (!_this_1._keyListInitialized && _this_1.options.connxtAllowSelect && _this_1.options.serverSide && _this_1.options.url) {
                    _this_1.getKeyDataFromServer(null).then(function (callbackResult) {
                        _this_1._datatableKeyList = callbackResult.data.map(function (d) { return d[_this_1._tableKeyProperty].toString(); });
                        if (_this_1._keyListInitializedWithAllSelected) {
                            _this_1._datatableSelectedList = __spreadArray([], _this_1._datatableKeyList, true);
                        }
                        _this_1.updateCheckboxState();
                    }).catch(function (error) {
                        console.error("An error occured while getting the id list for datatable: ".concat(error));
                    });
                    _this_1._keyListInitialized = true;
                }
                _this_1.callbackFuncion(dataTableSettings);
                _this_1.updateCheckboxState();
            });
        });
        this.datatable.on('column-visibility.dt', function (e, settings, column, state) {
            var _a;
            (_a = _this_1.datatable) === null || _a === void 0 ? void 0 : _a.ajax.reload();
        });
    };
    CoreDataTableV2.prototype.combineListsWithDistinct = function (originalList, toAdd) {
        for (var _i = 0, toAdd_1 = toAdd; _i < toAdd_1.length; _i++) {
            var item = toAdd_1[_i];
            if (!originalList.includes(item.toString())) {
                originalList.push(item.toString());
            }
        }
        return originalList;
    };
    CoreDataTableV2.prototype.getKeyDataFromServer = function (searchValue) {
        var csrfToken = IctCoreJsApp_1.$app.getAntiForgeryCookie();
        var parameters = [];
        if (this.datatable) {
            parameters = this.datatable.ajax.params()['parameters'];
        }
        parameters.push({ Name: "get-key-data-call", Value: "true" });
        return $.ajax({
            url: this.options.url,
            type: 'post',
            data: { parameters: parameters, start: 0, length: -1, search: { value: searchValue, regex: "false" }, columns: [{ data: this._tableKeyProperty, name: this._tableKeyProperty, searchable: true, orderable: true, search: { value: null, regex: "false" } }] },
            headers: {
                'X-CSRF-TOKEN': csrfToken
            }
        });
    };
    CoreDataTableV2.prototype.changeSelectedFooterCount = function () {
        var _a, _b;
        var $selectCount = $("[id='".concat($(this.element).attr('id'), "_select_count'] .selected_count_label"));
        if (this._datatableSelectedList.length != 0 && !this._isSearching && this._datatableSelectedList.length == this._datatableKeyList.length) {
            $selectCount.empty();
            $selectCount.append($(this.element).data('localized-select-label-all'));
            var tableId_2 = $(this.element).attr('id');
            (_a = document.getElementById(tableId_2)) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new CustomEvent("selectionChanged", { detail: { selectedIds: this._datatableSelectedList } }));
            return;
        }
        $selectCount.empty();
        $selectCount.append(this._datatableSelectedList.length.toString());
        var tableId = $(this.element).attr('id');
        (_b = document.getElementById(tableId)) === null || _b === void 0 ? void 0 : _b.dispatchEvent(new CustomEvent("selectionChanged", { detail: { selectedIds: this._datatableSelectedList } }));
    };
    CoreDataTableV2.prototype.setSearchDebounce = function (table, delay) {
        var _this = this;
        var searchInput = this.element.closest('.dataTables_wrapper').find('input[type=search]');
        searchInput.off();
        searchInput.on('input', this.delaySearch(function () {
            var _a, _b;
            var searchString = (_b = (_a = $(this).val()) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '';
            _this._isSearching = searchString.length > 0;
            _this._searchString = searchString;
            if (_this.options.serverSide) {
                table.search(searchString).draw();
                return;
            }
            _this.searchClientSideTable(table, searchString);
        }, delay));
    };
    CoreDataTableV2.prototype.searchClientSideTable = function (table, searchValue) {
        var _a;
        var searchTerms = [];
        table.rows().remove();
        table.rows.add(this.allRows);
        table.draw();
        if (!searchValue || searchValue.trim().length == 0) {
            return;
        }
        var regex = new RegExp('(-?"[\\w\\s-]+")|(-?[\\w-]+)', 'g');
        var searchMatches = (_a = searchValue.match(regex)) !== null && _a !== void 0 ? _a : [];
        var searchValues = Array.from(new Set(searchMatches.map(function (s) { return s.replaceAll('"', ''); })));
        searchTerms = searchValues.map(function (v) {
            var isNegative = v.length > 1 && v.startsWith('-');
            var term = isNegative ? v.substring(1) : v;
            if (term) {
                return {
                    IsNegative: isNegative,
                    Term: term
                };
            }
        });
        if (searchTerms.length === 0) {
            return;
        }
        table.rows(function (rowIdx, data) {
            var keepRow = true;
            var rowAsString = '';
            if (data) {
                rowAsString = Object.values(data).join(' ');
            }
            var positiveSearchTerms = searchTerms.filter(function (d) { return !d.IsNegative; });
            for (var _i = 0, positiveSearchTerms_1 = positiveSearchTerms; _i < positiveSearchTerms_1.length; _i++) {
                var positiveSearchTerm = positiveSearchTerms_1[_i];
                if (!rowAsString.toLowerCase().includes(positiveSearchTerm.Term.toLowerCase())) {
                    keepRow = false;
                    break;
                }
            }
            if (keepRow) {
                var negativeSearchTerms = searchTerms.filter(function (d) { return d.IsNegative; });
                for (var _a = 0, negativeSearchTerms_1 = negativeSearchTerms; _a < negativeSearchTerms_1.length; _a++) {
                    var negativeSearchTerm = negativeSearchTerms_1[_a];
                    if (rowAsString.toLowerCase().includes(negativeSearchTerm.Term.toLowerCase())) {
                        keepRow = false;
                        break;
                    }
                }
            }
            return !keepRow;
        })
            .remove()
            .draw();
    };
    CoreDataTableV2.prototype.delaySearch = function (callback, delay) {
        var timer;
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            clearTimeout(timer);
            timer = setTimeout(callback.bind.apply(callback, __spreadArray([this], args, false)), delay || 0);
        };
    };
    CoreDataTableV2.prototype.showLoader = function () {
        $(this.element).closest('div.dataTables_wrapper').showLoader();
    };
    CoreDataTableV2.prototype.hideLoader = function () {
        $(this.element).parents('div.dataTables_wrapper').first().show();
        $(this.element).closest('div.dataTables_wrapper').hideLoader();
    };
    CoreDataTableV2.prototype.getCustomLoader = function () {
        return $('#custom-loading-indicator').html();
    };
    CoreDataTableV2.prototype.callbackFuncion = function (dataTableSettings) {
        if (typeof (dataTableSettings["drawCallback"]) === "function") {
            dataTableSettings.drawCallback();
        }
    };
    return CoreDataTableV2;
}());
exports.CoreDataTableV2 = CoreDataTableV2;
var CoreDataTable = (function () {
    function CoreDataTable(element, options) {
        this.element = element;
        this.options = options;
    }
    CoreDataTable.prototype.Create = function () {
        var _a, _b;
        var _this = this;
        var dataTableSettings = {
            dom: '<"connxt-dt-top"<"pull-left"f><"pull-right table-buttons"B>><"connxt-dt-table table-responsive"rt><"connxt-dt-bottom"lip>',
            pagingType: 'full',
            buttons: []
        };
        if (_this.options != null) {
            if (_this.options.url != null) {
                dataTableSettings.ajax = {
                    url: _this.options.url,
                    type: 'POST',
                    beforeSend: function (request) {
                        request.setRequestHeader('X-CSRF-TOKEN', IctCoreJsApp_1.$app.getAntiForgeryCookie());
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        if (errorThrown != "abort") {
                            var message = '';
                            if (jqXHR.responseJSON != null && jqXHR.responseJSON.message != null) {
                                message = jqXHR.responseJSON.message;
                            }
                            if (message !== undefined && message != '') {
                                IctCoreJsApp_1.$app.mdbootbox.alert(message);
                            }
                            console.error("Failed to get data for datatable: ".concat(message));
                            _this.hideLoader();
                        }
                    }
                };
                if (_this.options.data != null) {
                    dataTableSettings.ajax.data = _this.options.data;
                }
            }
            dataTableSettings.processing = _this.options.processing;
            dataTableSettings.serverSide = _this.options.serverSide;
            if (_this.options.columns != null) {
                dataTableSettings.columns = _this.options.columns;
            }
            if (_this.options.columnDefs != null) {
                dataTableSettings.columnDefs = _this.options.columnDefs;
            }
            if (_this.options.order != null) {
                dataTableSettings.order = _this.options.order;
            }
            if (_this.options.stateSave != null) {
                dataTableSettings.stateSave = _this.options.stateSave;
                dataTableSettings.stateDuration = -1;
                dataTableSettings.stateSaveCallback = (_a = this.options) === null || _a === void 0 ? void 0 : _a.stateSaveCallback;
                dataTableSettings.stateLoadCallback = (_b = this.options) === null || _b === void 0 ? void 0 : _b.stateLoadCallback;
            }
            if (_this.options.stateDuration != null) {
                dataTableSettings.stateDuration = _this.options.stateDuration;
            }
            if (_this.options.paging != null) {
                dataTableSettings.paging = _this.options.paging;
            }
            if (_this.options.createdRow != null) {
                var createdRow_1 = _this.options.createdRow;
                dataTableSettings.createdRow = function (row, data, dataIndex) {
                    createdRow_1(row, data, dataIndex);
                };
            }
            if (_this.options.drawCallback != null) {
                var drawCallback_1 = _this.options.drawCallback;
                dataTableSettings.drawCallback = function (settings) {
                    drawCallback_1(settings);
                };
            }
            if (_this.options.searching != null) {
                dataTableSettings.searching = _this.options.searching;
            }
            if (_this.options.deferLoading != null) {
                dataTableSettings.deferLoading = _this.options.deferLoading;
            }
            _this.showLoader();
            if (_this.options.initComplete != null) {
                var init_1 = _this.options.initComplete;
                dataTableSettings.initComplete = function (settings) {
                    init_1();
                    _this.hideLoader();
                    if (_this.datatable) {
                        _this.datatable.columns.adjust();
                    }
                };
            }
            else {
                dataTableSettings.initComplete = function (settings) {
                    _this.hideLoader();
                    if (_this.datatable) {
                        _this.datatable.columns.adjust();
                    }
                };
            }
            if (_this.options.language != null) {
                dataTableSettings.language = dataTablesLanguages[_this.options.language];
            }
            else {
                dataTableSettings.language = dataTablesLanguages[_this.getLanguage()];
            }
            var loaderOverride = _this.getCustomLoader();
            if (loaderOverride) {
                dataTableSettings.language.processing = "<div class=\"dt-processing-overlay\">" + loaderOverride + "</div>";
            }
            if (_this.options.pageLength != null) {
                dataTableSettings.pageLength = _this.options.pageLength;
            }
        }
        this.initDataTable(dataTableSettings);
    };
    CoreDataTable.prototype.initDataTable = function (dataTableSettings) {
        this.datatable = $(this.element).DataTable(dataTableSettings);
    };
    CoreDataTable.prototype.getLanguage = function () {
        return IctCoreJsApp_1.$app.getLanguageFromDocument();
    };
    CoreDataTable.prototype.showLoader = function () {
        this.element.closest('.data-table').parent().showLoader();
    };
    CoreDataTable.prototype.hideLoader = function () {
        this.element.closest('.data-table').show();
        this.element.closest('.data-table').parent().hideLoader();
    };
    CoreDataTable.prototype.getCustomLoader = function () {
        return $('#custom-loading-indicator').html();
    };
    return CoreDataTable;
}());
exports.CoreDataTable = CoreDataTable;
$(document).on('click', 'th.select-checkbox', function (e) {
    var input = $(e.target).closest('th').find('input');
    if ($(input).attr('checked') === 'checked') {
        $(input).removeAttr('checked');
        $(input).closest("table").DataTable().rows().deselect();
    }
    else {
        $(input).attr('checked', 'checked');
        $(input).closest("table").DataTable().rows().select();
    }
    e.stopPropagation();
    return false;
});
var dataTablesLanguages = {
    en: {
        "emptyTable": "No data available in table",
        "info": "_START_ - _END_ of _TOTAL_",
        "infoEmpty": "0-0 of 0",
        "infoFiltered": "",
        "infoPostFix": "",
        "infoThousands": ",",
        "lengthMenu": "Rows per page: _MENU_",
        "loadingRecords": "",
        "processing": "<div class=\"dt-processing-overlay\"><svg class=\"circular\" viewBox=\"25 25 50 50\"><circle class=\"path\" cx=\"50\" cy=\"50\" r=\"20\" fill=\"none\" stroke-width=\"2\" stroke-miterlimit=\"10\"/></svg></div>",
        "search": "Search",
        "zeroRecords": "No matching records found",
        "paginate": {
            "first": "<i class='material-icons'>first_page</i>",
            "previous": "<i class='material-icons'>keyboard_arrow_left</i>",
            "next": "<i class='material-icons'>keyboard_arrow_right</i>",
            "last": "<i class='material-icons'>last_page</i>"
        },
        "aria": {
            "sortAscending": ": activate to sort column ascending",
            "sortDescending": ": activate to sort column descending"
        }
    },
    fr: {
        "emptyTable": "Aucune donn&eacute;e disponible dans le tableau",
        "info": "Affichage de l'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments",
        "infoEmpty": "0-0 sur 0",
        "infoFiltered": "",
        "infoPostFix": "",
        "infoThousands": ".",
        "lengthMenu": "Afficher _MENU_ &eacute;l&eacute;ments",
        "loadingRecords": "",
        "processing": "<div class=\"dt-processing-overlay\"><svg class=\"circular\" viewBox=\"25 25 50 50\"><circle class=\"path\" cx=\"50\" cy=\"50\" r=\"20\" fill=\"none\" stroke-width=\"2\" stroke-miterlimit=\"10\"/></svg></div>",
        "search": "Rechercher",
        "zeroRecords": "Aucun &eacute;l&eacute;ment &agrave; afficher",
        "paginate": {
            "first": "<i class='material-icons'>first_page</i>",
            "previous": "<i class='material-icons'>keyboard_arrow_left</i>",
            "next": "<i class='material-icons'>keyboard_arrow_right</i>",
            "last": "<i class='material-icons'>last_page</i>"
        },
        "aria": {
            "sortAscending": ": activer pour trier la colonne par ordre croissant",
            "sortDescending": ": activer pour trier la colonne par ordre d&eacute;croissant"
        }
    },
    de: {
        "emptyTable": "Keine Daten in der Tabelle vorhanden",
        "info": "_START_ bis _END_ von _TOTAL_ Einträgen",
        "infoEmpty": "0-0 von 0",
        "infoFiltered": "",
        "infoPostFix": "",
        "infoThousands": ".",
        "lengthMenu": "_MENU_ Einträge anzeigen",
        "loadingRecords": "",
        "processing": "<div class=\"dt-processing-overlay\"><svg class=\"circular\" viewBox=\"25 25 50 50\"><circle class=\"path\" cx=\"50\" cy=\"50\" r=\"20\" fill=\"none\" stroke-width=\"2\" stroke-miterlimit=\"10\"/></svg></div>",
        "search": "Suchen",
        "zeroRecords": "Keine Einträge vorhanden",
        "paginate": {
            "first": "<i class='material-icons'>first_page</i>",
            "previous": "<i class='material-icons'>keyboard_arrow_left</i>",
            "next": "<i class='material-icons'>keyboard_arrow_right</i>",
            "last": "<i class='material-icons'>last_page</i>"
        },
        "aria": {
            "sortAscending": ": aktivieren, um Spalte aufsteigend zu sortieren",
            "sortDescending": ": aktivieren, um Spalte absteigend zu sortieren"
        }
    },
    nl: {
        "emptyTable": "Geen resultaten aanwezig in de tabel",
        "info": "_START_ - _END_ van _TOTAL_",
        "infoEmpty": "0-0 van 0",
        "infoFiltered": "",
        "infoPostFix": "",
        "infoThousands": ".",
        "lengthMenu": "Aantal per pagina: _MENU_",
        "loadingRecords": "",
        "processing": "<div class=\"dt-processing-overlay\"><svg class=\"circular\" viewBox=\"25 25 50 50\"><circle class=\"path\" cx=\"50\" cy=\"50\" r=\"20\" fill=\"none\" stroke-width=\"2\" stroke-miterlimit=\"10\"/></svg></div></div>",
        "search": "Zoeken",
        "zeroRecords": "Geen resultaten gevonden",
        "paginate": {
            "first": "<i class='material-icons'>first_page</i>",
            "previous": "<i class='material-icons'>keyboard_arrow_left</i>",
            "next": "<i class='material-icons'>keyboard_arrow_right</i>",
            "last": "<i class='material-icons'>last_page</i>"
        },
        "aria": {
            "sortAscending": ": activeer om kolom oplopend te sorteren",
            "sortDescending": ": activeer om kolom aflopend te sorteren"
        }
    }
};
